<template>
  <div class='index-page' :style="{ paddingLeft:(isCollapse == false ? '200px':'64px')  }">
    <!-- 首页 -->
    <div class="radio-box"   :style="{width:(isCollapse == false ? '200px':'64px')}">
      <el-menu :default-active="activeIndex" class="el-menu-vertical-demo"  :collapse="isCollapse" :unique-opened="true" :collapse-transition="false"
        background-color="#202741" text-color="#A9ABB3"	active-text-color="#2BC17B" router>
        <div class="le-title">教育管理系统</div>
        <template v-for="(el,index) in child">
          <el-menu-item v-if="!el.children" :index="el.path" :key="el.id">
            <span slot="title">{{el.name}}</span>
          </el-menu-item>
          <el-submenu v-else :index="'index' + index" :key="el.id || ('item-' + index)">
            <template slot="title">
              <i :class="el.icon"></i>
              <span>{{el.name}}</span>
            </template>
            <el-menu-item :index="children.path" v-for="children in el.children" :key="children.id">
              {{children.name}}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>

    </div>

    <div class="body"  >
      <div class="topbanner">
        <el-button class="incon" :icon=" !isCollapse  ? 'el-icon-s-fold':'el-icon-s-unfold' " @click="isCollapse = !isCollapse"></el-button> 
        <span class="user">{{ userType === 1 ? '教师' : userType === 2 ? '学生' : '未知' }}：{{ username }}</span>
        <el-button class="loy"   @click="layout">退出</el-button> 
      </div>
      <div class="body-box">
        <router-view   class="router-view"  />
      </div>
    </div>
  </div>
</template>

<script>
// import child from '@/router/views/index';
import { getToken } from '@/util/auth';
import { readMenu } from '@/router/menu';
import staticChild from '@/router/views/index';
  export default {
    name:'',
    data(){
      return{
        isCollapse: false,
        username: getToken('username'),
        child:[...staticChild, ...readMenu()],
        activeIndex: this.$route.path,
        userType: Number(getToken('user_type')) || 0,
      }
    },
    components: {},
    created(){
      
    },
    mounted(){},
    activated(){},
    computed:{},
    methods:{
      bodywidth(){
        return  this.isCollapse == false ? 'width: calc(100% -200px)':' width: calc(100% -64px) '  ; 
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      layout(){
        // console.log("layout", this.$store)
        this.$store.commit('layout')
      }
    },
 }
</script>

<style lang='less' >
.index-page {
  height: 100%;
  // display: flex;
  position: relative;
  // transition:  padding-left  .3s;
  .el-menu-vertical-demo {
    height: 100%;
    
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
    
  }
  .radio-box {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #fff;
    // transition:  width  .3s;
    .le-title {
      height: 64px;
      line-height: 64px;
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      color: #A9ABB3;
    }
  }
  .body {
    height: 100%;
    width: 100%;
    // transition:  width  .3s;
    .topbanner {
      height: 64px;
      background-color: #fff;
      position: relative;
      .incon {
        position: absolute;
        left: 12px;
        top: 7px;
        font-size: 20px;
      }
      .user {
        position: absolute;
        right: 100px;
        top: 22px;
        font-size: 18px;
        color: #2BC17B;
      }
      .loy {
        position: absolute;
        right: 12px;
        top: 12px;
      }
    }
    .body-box {
      height: calc(100% - 64px);
      padding: 12px;
      box-sizing: border-box;
      .router-view{ 
        height: 100%;
        width: 100%;
        // background-color: lime;
        background-color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/index/index.vue